import { useState } from "react";
import moment from "moment";
import { toast } from "react-toastify";
import userServiceApi from "../api/userServiceApi";
import { useStore } from "../store";
import { setTabData, setSkills, setTeamsAndRoles, setCoursesQualifications, setProductGroups } from "../store/actions";
import { getRequest, deleteRequest, postRequest } from "../api/http";
import { vacancyKeys, contract, contactUSkeys, aboutUsEnumsArr, TAB_KEYS } from "../config";
import { contactEnumsArr } from "../config";
import { useParams } from "react-router-dom";

export function useTab() {
  const { dispatch } = useStore();
  const { micrositeId } = useParams();

  const [loader, setLoader] = useState(true);
  const [postLoader, setPostLoader] = useState(false);

  const headers = {
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  };

  const transform = (data) => {
    let transformString = data?.toUpperCase()
    return transformString?.replace('-', '_')
  }
  const getSingleTabData = async (tabKey, form, tabConfigId) => {
    try {
      setLoader(true);

      const id = localStorage?.getItem('selectedTabId');

      const getApiEndpoint = () => {
        if (aboutUsEnumsArr.includes(tabKey) || aboutUsEnumsArr.includes(transform(tabKey))) {
          if (tabConfigId || id) {
            return userServiceApi.getAboutUsDetails(transform(tabKey), micrositeId, tabConfigId || id || localStorage?.getItem('selectedTabId'));
          }
          return userServiceApi.getMicrositeDetailsTabs(transform(tabKey), micrositeId, tabConfigId || localStorage?.getItem('selectedTabId'));
        }
        else if (contactEnumsArr.includes(tabKey) || contactEnumsArr.includes(transform(tabKey))) {
          return userServiceApi.getContactUsDetails(transform(tabKey), micrositeId);
        }
        else if (vacancyKeys.includes(tabKey) || vacancyKeys.includes(transform(tabKey))) {
          return userServiceApi.getMicrositeDetailsVacancyTab(transform(tabKey), micrositeId, tabConfigId || localStorage.getItem("selectedTabId"));
        } else if (contract === tabKey) {
          return userServiceApi.getMicrositeDetailsContractTab(micrositeId, tabConfigId || localStorage.getItem("selectedTabId"));
        }
        else if (TAB_KEYS.events === tabKey) {
          return userServiceApi.getEventMicrositeTabs(micrositeId, tabConfigId || localStorage.getItem("selectedTabId"));
        }
        else {
          return userServiceApi.getMicrositeDetailsTabs(transform(tabKey), micrositeId, tabConfigId || localStorage?.getItem('selectedTabId'));
        }
      };
      
      const response = await getRequest(getApiEndpoint(), { headers });
      if (response?.status === 200 && Array.isArray(response.data)) {
        form && form?.resetFields();
        const processedData = response?.data?.map(d => {
          if (d) {
            if (d.closingDate) d.closingDate = moment(d.closingDate);
            if (d.closeDate) d.closeDate = moment(d.closeDate);
            if (d.startDate) d.startDate = moment(d.startDate);
            if (d.endDate) d.endDate = moment(d.endDate);
            if (d.closeTime) d.closeTime = moment(d.closeTime);
          }
          return d;
        });
        dispatch(setTabData({ mainKey: transform(tabKey), data: processedData }));
        dispatch(setTabData({ mainKey: tabKey, data: processedData }));
      }
    } catch (error) {
      console.error('error', error);
    } finally {
      setLoader(false);
    }
  };

  const deleteSingleItem = async (tabKey, id, form) => {
    let tempTabKey = tabKey
    if (aboutUsEnumsArr.includes(tabKey)) {
      tempTabKey = "about-us"
    }
    try {
      const response = await deleteRequest(tempTabKey === 'ADDRESS' ?
        userServiceApi.updateContactUsSales(id)
        :
        vacancyKeys.includes(tempTabKey)
          ? userServiceApi.deleteApprenticeshipVacancies(micrositeId, tempTabKey, id)
          : contract === tempTabKey
            ? userServiceApi.deleteContractTab(id)
            :TAB_KEYS.events === tempTabKey
              ? userServiceApi.deleteEventMicrositeDetailsTabs(micrositeId, tempTabKey, id)
              :  userServiceApi.deleteMicrositeDetailsTabs(micrositeId, tempTabKey, id)
      );
      if (response || response?.id) {
        toast.success("Deleted successfully");
        getSingleTabData(tabKey, form);
      } else {
        toast.error("Failed to delete!!");
        localStorage.removeItem("delete", "yes")

      }
    } catch (error) {
      toast.error(error.error);
    }
    finally {
      setPostLoader(false);
    }
  };

  const createNewItem = async (tabKey, data, form, id) => {
    var headerList = {};
    if (contactEnumsArr.includes(tabKey)) {
      headerList = { headers };
    } else {
      headerList = {
        headers: { "Content-Type": "multipart/form-data", ...headers },
      };
    }

    try {
      setPostLoader(true);
      let apiCall;
      if (contactEnumsArr.includes(tabKey)) {
        if (tabKey === contactUSkeys.address) {
          apiCall = userServiceApi.createContactUsAddress(micrositeId, localStorage.getItem("selectedTabId"));
        }
        else {
          apiCall = userServiceApi.createContactUsSales(micrositeId, id);
          data = data[0];
        }
      }
      else if (aboutUsEnumsArr.includes(tabKey)) {
        apiCall = userServiceApi.putAboutUsDetails(micrositeId);

      }
      else if (vacancyKeys.includes(tabKey)) {
        apiCall = userServiceApi.createApprenticeshipVacancies(micrositeId);
      } else if (contract === tabKey) {
        apiCall = userServiceApi.createContractDetails(micrositeId);
      }
      else if (tabKey === TAB_KEYS.events) {
        apiCall = userServiceApi.createEventMicrositeTabs(id, micrositeId);

      }

      else {
        apiCall = userServiceApi.createMicrositeTabs(tabKey, micrositeId);
      }
      let response
      response = await postRequest(apiCall, data, headerList, id);

      if (response) {
        setPostLoader(false);
        getSingleTabData(tabKey, form);
        toast.success("Data created successfully");
      } else {
        console.log('error posting data')
      }
    } catch (error) {
      console.log('error posting data', error)

    }
    finally {
      setPostLoader(false);
    }
  };

  const updateItems = async (tabKey, data, isAdd, form, id) => {
    console.log("updateItems called:178");
    setPostLoader(true);

    try {
      let apiCall;
      let isFormData = false;

      // Determine API URL
      if (contactEnumsArr.includes(tabKey)) {
        if (contactUSkeys.address === tabKey) {
          apiCall = userServiceApi.createContactUsAddress(
            micrositeId,
            localStorage.getItem("selectedTabId")
          );
        } else {
          apiCall = userServiceApi.updateContactUsSales(
            data[0].sectionBlockId,
            micrositeId
          );
          data = data[0];
        }
      } else if (aboutUsEnumsArr.includes(tabKey)) {
        apiCall = userServiceApi.putAboutUsDetails(micrositeId);
      } else if (vacancyKeys.includes(tabKey)) {
        apiCall = userServiceApi.createApprenticeshipVacancies(micrositeId);
      } else if (contract === tabKey) {
        apiCall = userServiceApi.updateContractDetails(micrositeId);
      } else if (tabKey === TAB_KEYS.events) {
        apiCall = userServiceApi.updateEventMicrositeTabs(id, micrositeId);
      } else {
        apiCall = userServiceApi.updateMicrositeDetailsTabs(
          tabKey,
          micrositeId,
          id
        );
      }

      // Detect if FormData
      if (data instanceof FormData) {
        isFormData = true;
      }

      const response = await fetch(apiCall, {
        method: "PUT",
        headers: isFormData
          ? { ...headers } // do NOT set Content-Type for FormData
          : {
            "Content-Type": "application/json",
            ...headers,
          },
        body: isFormData ? data : JSON.stringify(data),
      });

      const result = await response.json();

      console.log("updateItems response:", result);

      // 🔥 Handle HTTP errors (400, 500 etc.)
      if (!response.ok) {
        throw new Error(
          result?.errorName ||
          result?.error ||
          result?.message ||
          "Something went wrong"
        );
      }

      // 🔥 Handle custom backend BAD_REQUEST (if HTTP is 200)
      if (result?.responseStatus === "BAD_REQUEST") {
        toast.error(result?.errorName || "Invalid parameters");
        return;
      }

      // ✅ Success
      getSingleTabData(tabKey, form);

      if (isAdd) {
        toast.success("Data created successfully");
      } else {
        toast.success("Data updated successfully");
      }

    } catch (error) {
      console.log("failed to update:", error.message);
      toast.error(error.message || "Something went wrong");
    } finally {
      setPostLoader(false);
    }
  };


  const callMicroServices = (tabKey, formData, form, id) => {
    console.log("callMicroServices:228",);
    if (formData["newData"]) {
      console.log("i am in if new data");
      if (tabKey === "ADDRESS") {
        updateItems(tabKey, formData["newData"], true, form, id);
      } else {
        createNewItem(tabKey, formData["newData"], form, id);
      }
    }

    if (formData["extraData"]) {
      console.log("i am in if extraData data");

      if (vacancyKeys.includes(tabKey)) {
        // createNewItem(tabKey, formData["extraData"], form);
        updateItems(tabKey, formData["extraData"], true, form, id);
      } else if (contract === tabKey || TAB_KEYS.news === tabKey || tabKey === "corousel" || tabKey === TAB_KEYS.service || tabKey === TAB_KEYS.events) {
        createNewItem(tabKey, formData["extraData"], form, id);
      }
      else {
        createNewItem(tabKey, formData["extraData"], true, form, id);
      }
    }

    if (formData["editedData"]) {
      console.log("i am in if editedData data");

      if (vacancyKeys.includes(tabKey) || contract === tabKey) {
        // createNewItem(tabKey, formData["editedData"], form);
        updateItems(tabKey, formData["editedData"], false, form, id);
      } else {
        updateItems(tabKey, formData["editedData"], false, form, id);
      }
    }
  };

  const getSkills = async () => {
    try {
      const response = await getRequest(userServiceApi.getAllSkills(), {
        headers,
      });
      if (response && response.data) {
        dispatch(setSkills(response.data));
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getOptions = async (micrositeId, activeKey, id) => {
    try {
      const response = await getRequest(userServiceApi.getTeamsCoursesProducts(micrositeId, id));
      if (response && response.data) {
        if (activeKey === "PRODUCT") {
          dispatch(setProductGroups(response.data));
        } else if (activeKey === "COURSES") {
          dispatch(setCoursesQualifications(response.data));
        } else if (activeKey === "TEAMS_AND_ROLES") {
          dispatch(setTeamsAndRoles(response.data));
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  return {
    getSingleTabData,
    deleteSingleItem,
    callMicroServices,
    getSkills,
    getOptions,
    dataLoader: loader,
    postLoader,
  };
}
